export const SET_LOADER_STATUS = 'SET_LOADER_STATUS';
export const SET_SELECTED_MENU_ITEMS = 'SET_SELECTED_MENU_ITEMS';
export const SET_ANCHOR_REF = 'SET_ANCHOR_REF';
export const SET_DEFAULT_EVENT = 'SET_DEFAULT_EVENT';
export const SET_HIDE_PENDING_EVENTS = 'SET_HIDE_PENDING_EVENTS';